/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line



       // Product page Pop-up 
      // Yan Pop-up Pencereyi açma işlemi
      document.getElementById('openPopup').addEventListener('click', function(event) {
          var popup = document.getElementById('popupContainer');
          popup.style.display = 'block';
      
          // Pencere üzerine tıklanınca kapatma işlemini engelle
          popup.addEventListener('click', function(e) {
              e.stopPropagation();
          });
      
          // Belge üzerine tıklandığında pencereyi kapatma dinleyicisini ekle
          document.addEventListener('click', closePopupOnClickOutside);
      });
      
      // Pencereyi kapatma işlemi
      document.getElementById('closePopup').addEventListener('click', function(event) {
          var popup = document.getElementById('popupContainer');
          popup.style.display = 'none';
      
          // Belge üzerine tıklanınca pencereyi kapatma dinleyicisini kaldır
          document.removeEventListener('click', closePopupOnClickOutside);
      
          // Olayın belge üzerinde yayılmasını engelle
          event.stopPropagation();
      });
      
      // Belge üzerine tıklandığında pencereyi kapatma işlemi
      function closePopupOnClickOutside(event) {
          var popup = document.getElementById('popupContainer');
      
          // Tıklanan öğe pencere veya açma düğmesi değilse pencereyi kapat
          if (event.target !== popup && event.target !== document.getElementById('openPopup')) {
              popup.style.display = 'none';
              document.removeEventListener('click', closePopupOnClickOutside);
          }
      }




     // Custom Tab (Size guide tab, etc)

    const tabs = document.querySelectorAll('.elyssa-tab');
    const tabContents = document.querySelectorAll('.tab-pane');

    tabs.forEach(tab => {
        tab.addEventListener('click', () => { // Tıklamaya dayalı etkileşim
            const tabNumber = tab.getAttribute('data-tab');

            // Tüm sekme butonlarını ve içerikleri gizle
            tabs.forEach(t => t.classList.remove('active'));
            tabContents.forEach(tc => tc.classList.remove('active'));

            // Seçilen sekme butonunu ve içeriğini göster
            tab.classList.add('active');
            document.querySelector(`.tab-pane[data-tab="${tabNumber}"]`).classList.add('active');
        });
    });


    const accordionItems = document.querySelectorAll('.elyssa-accordion-item');

    accordionItems.forEach(item => {
        const header = item.querySelector('.elyssa-accordion-header');
        const content = item.querySelector('.elyssa-accordion-content');

        header.addEventListener('click', () => {
            // Eğer tıklanan öğe zaten aktifse, kapat
            if (item.classList.contains('active')) {
                item.classList.remove('active');
            } else {
                // Tüm elyssa accordion öğelerini gizle
                accordionItems.forEach(i => i.classList.remove('active'));

                // Seçilen elyssa accordion öğesini göster
                item.classList.add('active');
            }
        });
    });



     //  Pırlanta guide slider box script     
 

      const slides = document.querySelectorAll('.slide');
      const prevButton = document.querySelector('.prev');
      const nextButton = document.querySelector('.next');
      let currentIndex = 0;
    
      function showSlide(index) {
        slides.forEach((slide, i) => {
          slide.style.display = i === index ? 'block' : 'none';
        });
      }
    
      function goToSlide(index) {
        if (index < 0) {
          index = slides.length - 1;
        } else if (index >= slides.length) {
          index = 0;
        }
        currentIndex = index;
        showSlide(currentIndex);
      }
    
      prevButton.addEventListener('click', () => {
        goToSlide(currentIndex - 1);
      });
    
      nextButton.addEventListener('click', () => {
        goToSlide(currentIndex + 1);
      });
    
      showSlide(currentIndex);



         //  Pırlanta guide diamons shape  


    const sliderInput = document.getElementById('slider');
    const aciklamaParagraf = document.getElementById('aciklama-metni');
    const sliderResim = document.getElementById('slider-resim');
    const grafik = document.querySelector('.grafik');

    const etiketler = ['Fair', 'Good', 'Very Good', 'Ideal', 'Super Ideal'];
    const bilgiler = {
      'Fair': 'Good quality cut which reflects some light while maximizing weight. While not as brilliant as a good cut, still a quality diamond.',
      'Good': 'Good açıklaması burada görünecek.',
      'Very Good': 'Very Good açıklaması burada görünecek.',
      'Ideal': 'Ideal açıklaması burada görünecek.',
      'Super Ideal': 'Cut to the most exacting standards. These diamonds have the most desirable dimensions and are proportioned to return the maximum possible light.'
    };
    const resimler = {
      'Fair': 'https://cdn.shopify.com/s/files/1/0699/5761/5902/files/cut-scale-1-fair.png?v=1692954108',
      'Good': 'https://cdn.shopify.com/s/files/1/0699/5761/5902/files/cut-scale-2-good.png?v=1692955183',
      'Very Good': 'https://cdn.shopify.com/s/files/1/0699/5761/5902/files/cut-scale-3-very-good.png?v=1692955243',
      'Ideal': 'https://cdn.shopify.com/s/files/1/0699/5761/5902/files/cut-scale-4-ideal.png?v=1692954863',
      'Super Ideal': 'https://cdn.shopify.com/s/files/1/0699/5761/5902/files/cut-scale-5-super-ideal.png?v=1692954915'
    };

    sliderInput.addEventListener('input', sliderDegeriDegistir);

    function sliderDegeriDegistir() {
      const deger = etiketler[parseInt(sliderInput.value, 10) - 1];
      aciklamaParagraf.textContent = bilgiler[deger];
      sliderResim.src = resimler[deger];
      grafik.style.backgroundImage = `url(${resimler[deger]})`;
    }

    // Başlangıçta ilk değeri yükle
    sliderDegeriDegistir();




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
